'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colorsTheme = require('./colorsTheme.js');
var typographyTheme = require('./typographyTheme.js');
var createMuiTheme = require('../node_modules/@material-ui/core/esm/styles/createMuiTheme.js');

var styles = {
  palette: {
    type: 'dark',
    primary: {
      light: '#9E9E9E',
      main: '#212121',
      dark: '#757575',
      contrastText: '#FFFFFF' //White

    },
    secondary: {
      main: '#FFFFFF' //White

    },
    error: colorsTheme.error,
    alert: colorsTheme.alert,
    success: colorsTheme.success,
    info: colorsTheme.info,
    common: colorsTheme.common,
    grey: colorsTheme.grey,
    background: {
      paper: '#212121'
    }
  },
  customShadows: {
    card: '0px 0px 12px 2px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1)'
  },
  spacer: typographyTheme.spacer,
  typography: typographyTheme.typography
};
var darkTheme = createMuiTheme(styles);

exports.darkTheme = darkTheme;
exports.styles = styles;
